import './navigation.html.twig';
import './navigation.css';

export default function() {
  const el = document.querySelector('.navigation');

  if (!el) {
    return;
  }

  const mql = window.matchMedia('(min-width: 991px)');
  if (mql.matches) {
    [...el.querySelectorAll('ul > li > span')].forEach(item => {
      if (item.innerHTML.toLowerCase().match(/exam/)) {
        item.parentElement.classList.add('navigation--exam');
      }
    });
  }

  const mobileNav = document.querySelector('.navigation__mobile-nav');
  if (mobileNav) {
    mobileNav.addEventListener('click', () => {
      mobileNav.classList.toggle('navigation__mobile-nav--active');
      el.classList.toggle('navigation--open');
    });
  }

  el.querySelectorAll('.navigation > ul > li').forEach(item => {
    item.setAttribute('aria-expanded', 'false');
    item.addEventListener('click', () => {
      el.querySelectorAll('.navigation > ul > li.active').forEach(openItem => {
        if (openItem !== item) {
          openItem.classList.remove('active');
          openItem.setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.toggle('active');
      if (item.classList.contains('active')) {
        item.setAttribute('aria-expanded', 'true');

        const fn = e => {
          if (!item.contains(e.target)) {
            item.click();
            document.removeEventListener('click', fn);
          }
        };
        document.addEventListener('click', fn);
      } else {
        item.setAttribute('aria-expanded', 'false');
      }
    });

    el.querySelectorAll('.navigation > ul > li > span').forEach(title => {
      title.tabIndex = 0;
    });

    item.addEventListener('keydown', e => {
      if (e.keyCode === 13) {
        item.click();
      }
    });
  });

  const searchButton = document.querySelector('.navigation__search__toggle');
  const searchBox = document.querySelector('.navigation__search__box');

  if (searchButton && searchBox) {
    searchButton.addEventListener('click', () => searchBox.focus());
    searchBox.addEventListener('focus', () =>
      document.querySelector('.navigation__search').classList.add('navigation__search--open')
    );
    searchBox.addEventListener('blur', () =>
      document.querySelector('.navigation__search').classList.remove('navigation__search--open')
    );
  }

  const close = document.querySelector('.navigation__search--close');
  if (close) {
    close.addEventListener('click', () => close.blur());
  }
}
